import { Provider } from 'react-redux';
import store from './redux/store';
import Calculator from './components/Calculator';
import './AppCalculadoraJS.css';

const AppCalculadoraJS = () => {
  return(
    <Provider store={store}>
      <div className="AppCalculadoraJS">
        <Calculator />
      </div>
    </Provider>
  );
}

export default AppCalculadoraJS;
